import { useQueryWithUserId } from '@northladder/services';

import { ACCOUNT_SERVICE_API } from '../accountServiceApiClient';
import { IExportAccountTransactionsUrlOptions } from '../types';

/**
 * This is to track the export account transactions query in react query cache.
 */
const EXPORT_ACCOUNT_TRANSACTIONS_KEY = 'export-account-transactions-query-key';

/**
 * This hook calls the export account transactions api to export the transactions
 * in an excel.
 */
export const useExportAccountTransactionsQuery = (
  queryParams: IExportAccountTransactionsUrlOptions
) => {
  const { fromDate, toDate, storeId, isSummaryRequired } = queryParams;

  const { data, isError, error, isPending, isSuccess, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [
        EXPORT_ACCOUNT_TRANSACTIONS_KEY,
        fromDate,
        toDate,
        storeId,
        isSummaryRequired,
      ],
      enabled: false,
      retry: false,
      queryFn: () => ACCOUNT_SERVICE_API.exportAccountTransactions(queryParams),
    });

  return {
    error,
    isError,
    data,
    isPending,
    isSuccess,
    refetch,
  };
};
